/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestGetSettingRequest
 */
export interface RequestGetSettingRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestGetSettingRequest
     */
    baseId?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestGetSettingRequest
     */
    tenantId?: number;
}

/**
 * Check if a given object implements the RequestGetSettingRequest interface.
 */
export function instanceOfRequestGetSettingRequest(value: object): value is RequestGetSettingRequest {
    return true;
}

export function RequestGetSettingRequestFromJSON(json: any): RequestGetSettingRequest {
    return RequestGetSettingRequestFromJSONTyped(json, false);
}

export function RequestGetSettingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestGetSettingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'baseId': json['base_id'] == null ? undefined : json['base_id'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
    };
}

export function RequestGetSettingRequestToJSON(json: any): RequestGetSettingRequest {
    return RequestGetSettingRequestToJSONTyped(json, false);
}

export function RequestGetSettingRequestToJSONTyped(value?: RequestGetSettingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base_id': value['baseId'],
        'tenant_id': value['tenantId'],
    };
}

